import { toast } from "react-toastify";

export function successToast(message) {
    toast(message, { type: "success" });
}

export function errorToast(message) {
    toast(message, { type: "error" });
}

export function infoToast(message) {
    toast(message, { type: "info" });
}
